import { useTranslations } from 'next-intl';

import { useWalletsControllerGetBalance } from '~/lib/api';

import { SvgTinyTon } from '@bazaar-marketplace/assets/tiny-ton';
import { useRouter } from 'next/navigation';
import { ROUTES } from '~/constants';
import { useConnectUserWallet } from '~/module/wallet/user-wallet/useConnectUserWallet';
import { formatCompactNumber } from '~/lib/formatters/format-compact-number';

export const WalletConnectButton = () => {
  const t = useTranslations('homepage');
  const router = useRouter();

  const connectWallet = useConnectUserWallet();
  const { data: balance } = useWalletsControllerGetBalance(
    {},
    {
      query: {
        staleTime: 60_000,
      },
    },
  );

  const currentBalance = formatCompactNumber(balance?.data.balance ?? '0');

  const handleClick = () => {
    if (connectWallet.connectedWallet) {
      router.push(ROUTES.WALLET);
    } else {
      connectWallet.openConnectUI();
    }
  };

  return (
    <div className="absolute backdrop-blur-[25px] bg-[#0D0D0D33] rounded-[20px] p-2 z-100 top-24 right-2 flex items-center gap-2">
      {connectWallet.connectedWallet ? (
        <span className="flex gap-1 items-center">
          <SvgTinyTon className="text-white size-3" />
          <span className="font-bold text-sm">{currentBalance}</span>
        </span>
      ) : null}
      <button
        className="bg-[#FFFFFF1A] rounded-[16px] backdrop-blur-[25px] font-bold text-white flex justify-center items-center px-6 py-2 hover:bg-[#FFFFFF2A] transition-colors"
        onClick={handleClick}
      >
        {connectWallet.connectedWallet ? t('wallet') : t('connect')}
      </button>
    </div>
  );
};
